import React from 'react';
import HeaderTable from '../headerTable/headerTable';

/**
 * Componente especializado para mostrar tabla de ranking de tenis
 * Renderiza el ranking de jugadores con posición, nombre y puntos
 * Limita la visualización a los primeros 25 jugadores
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.dataTab1 - Datos del ranking de tenis
 * @param {Object} props.dataTab1.tennisStages - Objeto con datos del torneo
 * @param {Array} props.dataTab1.tennisStages.ranking - Array de jugadores
 * 
 * @returns {JSX.Element} Tabla de ranking de tenis optimizada
 */
export default function TableTenis({ dataTab1 }) {
  const tennisData = dataTab1?.tennisStages || {};
  const ranking = Array.isArray(tennisData.ranking) ? tennisData.ranking : [];
  
  // Filtrar y validar jugadores, limitar a 25
  const validPlayers = ranking
    .filter(player => player && typeof player.position === 'number' && player.position > 0)
    .slice(0, 25);

  const getPositionChangeClass = (position, lastPosition) => {
    if (!lastPosition || position === lastPosition) return null;
    return position < lastPosition ? 'position-up' : 'position-down';
  };

  const getNationalityClass = (nationality) => {
    return nationality?.length === 3 ? `bandera-${nationality}` : 'bandera-default';
  };

  return (
    <>
      <div className="positions-table__header">
        <HeaderTable title={'Ranking de Jugadores'} />
      </div>

      <div className="positions-table__sport">
        {validPlayers.length > 0 ? (
          <table className="positions-table table-tenis">
            <thead>
              <tr>
                <th>POS.</th>
                <th>NOMBRE</th>
                <th>PTS</th>
              </tr>
            </thead>
            <tbody>
              {validPlayers.map((player, index) => {
                const changeClass = getPositionChangeClass(player.position, player.lastPosition);
                const nationalityClass = getNationalityClass(player.nationality);
                
                return (
                  <tr key={player.playerId || `player-${index}`}>
                    <td className="position-item">
                      <span className="position-number">{player.position}</span>
                      {changeClass && <div className={`position-change ${changeClass}`} />}
                    </td>
                    <td className="player-item">
                      <div className="player-info">
                        {player.nationality && <div className={`bandera-sport ${nationalityClass}`}></div>}
                        <span className="player-name decorationNone">{player.matchName || 'Nombre no disponible'}</span>
                      </div>
                    </td>
                    <td className="points-item">
                      <span className="points-value">
                        {typeof player.points === 'number' ? player.points.toLocaleString() : '-'}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="no-data">No hay datos de ranking disponibles</div>
        )}
      </div>
    </>
  );
}